(function (){
    'use strict';

    angular
        .module('services')
        .service('HighSchoolVisitService', HighSchoolVisitService);

    HighSchoolVisitService.$inject = ['$http', 'API_BASE'];

    function HighSchoolVisitService ($http, API_BASE) {
        var service = this;

        service.getExpos                        = getExpos;
        service.getSchoolsByCity                = getSchoolsByCity;
        service.getStudents                     = getStudents;
        service.getStudentsCsv                  = getStudentsCsv;
        service.getExpoUserAccommodations       = getExpoUserAccommodations;
        service.getExpoUserAccommodationsCsv    = getExpoUserAccommodationsCsv;
        service.getExpoUserTransportations      = getExpoUserTransportations;
        service.getExpoUserTransportationsCsv   = getExpoUserTransportationsCsv;  
        service.getExpoUserRepresentatives      = getExpoUserRepresentatives;  
        service.getExpoUserRepresentativesCsv   = getExpoUserRepresentativesCsv;  

        function getExpos(query)
        {
            return $http.get(API_BASE + '/schoolvisit/getexpos',{params:query})
                .then(function(response) {
                    return response;
                });
        }

        function getSchoolsByCity(query)
        {
            return $http.get(API_BASE + '/schoolvisit/getschoolsbyexpo',{params:query})
                .then(function(response) {
                    return response;
                });
        }

        function getStudents(query)
        {
            return $http.get(API_BASE + '/schoolvisit/students',{params:query})
                .then(function(response) {
                    return response;
                });
        }

        function getStudentsCsv(query)
        {
            return $http.get(API_BASE + '/schoolvisit/students/csv', {params: query});
        }

        function getExpoUserAccommodations(query)
        {
            return $http.get(API_BASE + '/schoolvisit/exhibitors/accommodations', {params: query});
        }

        function getExpoUserAccommodationsCsv(query)
        {
            return $http.get(API_BASE + '/schoolvisit/exhibitors/accommodations/csv', {params: query});
        }

        function getExpoUserTransportations(query)
        {
            return $http.get(API_BASE + '/schoolvisit/exhibitors/transportations', {params: query});
        }

        function getExpoUserTransportationsCsv(query)
        {
            return $http.get(API_BASE + '/schoolvisit/exhibitors/transportations/csv', {params: query});
        }

        function getExpoUserRepresentatives(query)
        {
            return $http.get(API_BASE + '/schoolvisit/exhibitors/representatives', {params: query});
        }

        function getExpoUserRepresentativesCsv(query)
        {
            return $http.get(API_BASE + '/schoolvisit/exhibitors/representatives/csv', {params: query});
        }
    }
})();